import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, map } from 'rxjs';
import { ServerTime } from './server-time.interface';

@Injectable({
  providedIn: 'root',
})
export class CloudflareTimeService implements ServerTime {
  private traceUrl = 'https://www.cloudflare.com/cdn-cgi/trace';

  constructor(private http: HttpClient) {}

  fetchServerTime(): Observable<number> {
    return this.http.get(this.traceUrl, { responseType: 'text' }).pipe(
      map((response) => {
        const serverTimeMatch = response.match(/(?<=\nts=)\d+\.\d+/);
        if (!serverTimeMatch) {
          throw new Error('Server time (ts) not found in the response.');
        }
        const serverTimeSeconds = parseFloat(serverTimeMatch[0]);
        return serverTimeSeconds * 1000;
      })
    );
  }
}